import {
  UserPreferencesQueries,
  UserQueries,
} from "@/application/queries/user.queries";
import { HomePage } from "@/interface/pages/home-page";
import PageLoader from "@/interface/pages/page-loader";
import { QueryClient } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_active-subscription/users/home")({
  component: RouteComponent,
  loader: async () => {
    const queryClient = new QueryClient();
    const user = await queryClient.fetchQuery(UserQueries.getCurrent());
    const userPreferences = await queryClient.fetchQuery({
      staleTime: Infinity,
      ...UserPreferencesQueries.getByUserID(user.id),
    });
    return { user, userPreferences };
  },
  pendingComponent: PageLoader,
});

function RouteComponent() {
  return <HomePage />;
}
